export default {
  title: 'Personal Information',
  save: 'Save',
  cancelMessageButton: 'Cancel',
  aboutYouLabel: 'About you',
  correspondence: {
    title: 'Correspondence',
    label: 'Language of correspondence',
    french: 'French',
    english: 'English',
  },
  emails: {
    title: 'Email',
    homeLabel: 'Primary email',
    homeConfirmLabel: 'Confirm primary email',
    workLabel: 'Secondary email (optional)',
    workConfirmLabel: 'Confirm secondary email (optional)',
    emailConfirmation: 'The 2 email addresses must be identical',
  },
  phones: {
    title: 'Phone',
    workPhoneLabel: 'Work phone (optional)',
    homePhoneLabel: 'Home phone',
    cellPhoneLabel: 'Cell phone (optional)',
    faxPhoneLabel: 'Fax (optional)',
    extentionPhoneLabel: 'Extention ',
    extentionValidation: 'The extension must be a number between 1 and 4 digits.',
  },
  address: {
    title: 'Address',
    newAdressLabel: 'New address',
    messageText: 'To change your address, please contact us at',
    apartment: 'Apartment',
    office: 'Office',
    postalBox: 'Postal box',
    ruralRoute: 'Rural route',
    none: 'None',
    countryCA: 'Canada',
    countryUS: 'United States',
  },
};
